<template>
  <main>
    <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
    <section-article
        v-if="article.title"
        id="scrollToOnLoad"
        :article="article"
        isTopSection="true">
    </section-article>
    <section class="experiments">
      <b-container>
        <div v-for="(experiment, i) in experimentsList" :key="i">
          <list-of-experiments :experiment="experiment"></list-of-experiments>
        </div>
        <router-link v-if="!experimentsList.length">
              <h3>{{ $t("prevResults.results") }}</h3>
          </router-link>
      </b-container>
      <router-link :to="{ path: `/report_my_results` }" tag="button"
          class="btn btn-primary report" v-scroll-to="'#scrollToOnLoad'">
          {{ $t("prevResults.check") }}
      </router-link>
    </section>
    <section-support></section-support>
  </main>
</template>

<script>
import game from '@/api/v1/game';
import prevResults from '@/api/v1/prevResults';
import Hero from '@/components/Hero';
import Article from '@/components/Article';
import ListOfExperiments from '@/components/ListOfExperiments';
import Support from '@/components/Support/Index';

export default {
  components: {
    'section-hero': Hero,
    'section-article': Article,
    'section-support': Support,
    ListOfExperiments,
  },
  data() {
    return {
      bgImg: 'Banner2-Experiment-',
      subtitle: this.$t('nav.experiment'),
      experimentsList: [],
      article: {},
    };
  },
  methods: {
    getExperimentsList() {
      const succ = (response) => {
        this.experimentsList = response.data.experiments
          .filter(experiment => experiment.has_results);
      };
      game.getExperimentsList(succ);
    },
    getTopSection() {
      const succ = (response) => {
        this.article = response.data.previous_results;
      };
      prevResults.index(succ);
    },
  },
  created() {
    this.getTopSection();
    this.getExperimentsList();
  },
};
</script>

<style lang="scss" scoped>
@import './src/styles/helpers/_variables.scss';
.experiments {
  padding: 0 0 100px,
}
.report {
  display: block;
  width: 40%;
  margin: 0 auto;
  border-radius: 23.5px;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/Game/PreviousResults.vue